import { Outlet } from "react-router-dom";

import Navbar from "../components/Navbar";

const BaseLayout = () => {
  return (
    <>
      <header className="hive-header sticky-top">
        <Navbar />
      </header>

      <Outlet />
    </>
  );
};

export default BaseLayout;
